import React from 'react'
import { DialogContentText, DialogContentTextProps } from '@material-ui/core'
import { darkBlue } from '../../styles/material-ui-theme-v2'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface IYumDialogContentText extends DialogContentTextProps {}

const YumDialogContentText = withStyles((theme: Theme) =>
  createStyles({
    root: { color: darkBlue, margin: 0 },
  }),
)(({ children, classes, ...props }: IYumDialogContentText) => {
  return (
    <DialogContentText classes={classes} {...props}>
      {children}
    </DialogContentText>
  )
})

export default YumDialogContentText
